import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/highcharts-more';
import 'highcharts/modules/solid-gauge';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { formatShortDate } from 'shared/utils/time/format-short-date';
import styles from './daily-ldm-ring.module.scss';
import type { IDailyLdmRingProps } from './types';
import { calculatePercent, getLdmRingOptions } from './utils';

export const DailyLdmRing: React.FC<IDailyLdmRingProps> = (props) => {
  const { dayLabel, date, ldmValue, weightValue, ldmGoal, weightGoal } = props;
  const ldmPercent = calculatePercent(ldmValue, ldmGoal);
  const weightPercent = calculatePercent(weightValue, weightGoal);

  const options = getLdmRingOptions(ldmPercent, weightPercent);

  return (
    <div className={styles.ringContainer}>
      <p className={styles.m0}>
        <strong>{dayLabel}</strong> {formatShortDate(date)}
      </p>
      <div className={styles.ringWrapper}>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
      <p className={styles.m0}>
        <strong className={styles.ldmLabel}>LDM:</strong> {numberFormatter(ldmValue)} / {numberFormatter(ldmGoal)} m.
      </p>
      <p className={styles.m0}>
        <strong className={styles.weightLabel}>Weight:</strong> {numberFormatter(weightValue)} /{' '}
        {numberFormatter(weightGoal)} kg.
      </p>
    </div>
  );
};
